import { useQuery } from "@apollo/client";
import teaserNodeQueryFilterTag from "../../../../teaser-base/queries/teaser-node-query-tag-filtered.graphql";

/**
 * Custom react hook that returns either manual nodes or auto nodes as state by given variables.
 * @param {array} manualNodes List of manual nodes directly selected in Drupal.
 * @param {object} options
 * @param {number} options.limit Amount of nodes to be fetched at a time.
 * @param {string} options.type Filter for content type of fetched nodes (machine name).
 * @param {array} options.tags List of tags to filter the results of fetched nodes.
 * @param {array} options.participantType Filter for speakers, acts, moderators seperately
 * @returns
 */
const useTeaserQuery = (manualNodes, options) => {
  const { data, loading, error } = useQuery(teaserNodeQueryFilterTag, {
    skip: options.mode === "manual",
    variables: {
      limit: options.limit || 100,
      type: options.type,
      tag: options.tags.map((item) => item.id),
      participantType: options.participantType,
      participantTypeEnabled: !!options.participantType,
      filterTagEnabled: options.tags.length > 0,
      filterNewsType: options.newsType || "news",
      newsTypeFilterEnabled: !!options.newsType
    },
  });

  const nodes = (options.mode === "manual" ? manualNodes : data?.entityQuery?.items) || [];

  return { nodes, loading, error };
};

export default useTeaserQuery;
